import { render, staticRenderFns } from "./ordersList.vue?vue&type=template&id=bc29ad40"
import script from "./ordersList.vue?vue&type=script&lang=js"
export * from "./ordersList.vue?vue&type=script&lang=js"
import style0 from "./ordersList.vue?vue&type=style&index=0&id=bc29ad40&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports